// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"headlineCarousel-module--wrapper--3079g","ctaButton":"headlineCarousel-module--ctaButton--3t2Xb"};